__turbopack_context__.v({
  "arrowIcon": "buttons-module-scss-module__bkWnla__arrowIcon",
  "button": "buttons-module-scss-module__bkWnla__button",
  "labelButton": "buttons-module-scss-module__bkWnla__labelButton",
  "menuTrigger": "buttons-module-scss-module__bkWnla__menuTrigger",
  "open": "buttons-module-scss-module__bkWnla__open",
});
